module.exports = __webpack_public_path__ + "img/newcar.0d324df8.jpg";